import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopShoppingCartActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ShoppingCart/ShoppingCartBrowser")
	}

	render() {
		return (
			<Activity 
				name="ShopShoppingCart"
				RenderedComponent={this.RenderedComponent}
				context="ShopShoppingCart"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopShoppingCartActivity)
